document.addEventListener('DOMContentLoaded', function () {
  const loginButton = document.querySelector('.btn-primary.button--login');
  const loginForm = document.querySelector('.form');

  if (loginButton) {
    loginButton.addEventListener('click', function (event) {
      event.preventDefault(); // zatrzymuje domyślne wysłanie formularza

      const username = loginForm.querySelector('[name="user_login"]').value.trim();
      const password = loginForm.querySelector('[name="user_pass"]').value.trim();
      const nonce = loginForm.querySelector('[name="login_nonce"]').value.trim();
      const smsCode = loginForm.querySelector('[name="sms_code"]').value.trim();

      if (username === '' || password === '') {
        return;
      }

      if (smsCode !== '') {
        loginForm.submit();
      }

      $.ajax({
        url: ajaxurl,
        data: {
          'action': 'show_sms_code_input',
          'username': username,
          'userpass': password,
          'nonce': nonce,
          'smsCode': smsCode
        },
        type: 'POST',
        timeout: 30000,
        success: function success(data) {
          if (data.errors || data.success === false) {
            loginForm.submit();
          } else {
            if (data.success) {
              loginForm.submit();
            } else {
              let phoneNumber = data.phoneNumber[0];

              if (!phoneNumber.length) {
                loginForm.submit();
              } else {
                let hidden_number = 'xxx-xxx-x';
                if (data.phoneNumber[0].length >= 2) {
                  hidden_number += data.phoneNumber[0].slice(-2);
                } else if (data.phoneNumber[0].length === 1) {
                  hidden_number += 'x' + data.phoneNumber[0].slice(-1);
                } else {
                  hidden_number += 'xx';
                }

                let new_text = loginForm.querySelector('[id="phone_hint"]').textContent.replace('xxx-xxx-xxx', hidden_number);
                loginForm.querySelector('[id="phone_hint"]').textContent = new_text;
                loginForm.querySelector('[id="phone_hint"]').style.display = 'block';
                loginForm.querySelector('[id="sms_phone_code"]').style.display = 'block';
                loginForm.querySelector('[id="sms_code"]').focus();
              }
            }
          }
        },
        error: function error(xhr, status, error) {
          if (status === "timeout") {
            const alert = loginForm.querySelector('[id="alert_login"]');
            alert.classList.add('show');
            setTimeout(() => alert.classList.remove("show"), 5000);
          } else {
            loginForm.submit();
          }
        }
      });
    });
  }
});